module.exports = __webpack_public_path__ + "img/bluebg.cfc64b03.webp";